/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['leaflet', 'services/copyright', './messageBox'], function(L, copyright, messageBox) {
    'use strict';

    var boundEventHandler, messageBoxInstance;

    function eventHandler(map) {
        copyright().boundingBox(map.getBounds())
            .callback(function(result) {
                if (messageBoxInstance) {
                    messageBoxInstance.remove();
                }
                messageBoxInstance = messageBox({content: result}).addTo(map);
            }).go();
    }

    return {
        updateEventHandler: function(map) {
            var tomtomAttribution = document.querySelector('#' + map.getContainer().id + ' .tomtomAttribution');
            if (tomtomAttribution) {
                if (boundEventHandler) {
                    L.DomEvent.off(tomtomAttribution, 'click', boundEventHandler);
                }
                boundEventHandler = eventHandler.bind(this, map);
                L.DomEvent.on(tomtomAttribution, 'click', boundEventHandler);
            }
        }
    };
});



// WEBPACK FOOTER //
// ./display/copyright.js